export const spacing = "1rem";
export const reviewTitle = " Roboto, Helvetica, Neue-Light, Segoe WP, Segoe UI, sans-serif";
export const breakpointTablet = 480;

// colors
export const colorLightBlue = "#1ba1e2";
export const grey2 = "#666666";
